
// Navigation Menu
export const DISPLAY_NAVIGATION_MENU = 'DISPLAY_NAVIGATION_MENU';
export const HIDE_NAVIGATION_MENU = 'HIDE_NAVIGATION_MENU';

// Start Arrow
export const DISPLAY_START_ARROW = 'DISPLAY_START_ARROW';
export const HIDE_START_ARROW = 'HIDE_START_ARROW';

// Product Details Modal
export const DISPLAY_PRODUCT_DETAILS_MODAL = 'DISPLAY_PRODUCT_DETAILS_MODAL';
export const HIDE_PRODUCT_DETAILS_MODAL = 'HIDE_PRODUCT_DETAILS_MODAL';

// Print Summary Modal
export const DISPLAY_PRINT_SUMMARY_MODAL = 'DISPLAY_PRINT_SUMMARY_MODAL';
export const HIDE_PRINT_SUMMARY_MODAL = 'HIDE_PRINT_SUMMARY_MODAL';

// Email Summary Modal
export const DISPLAY_EMAIL_SUMMARY_MODAL = 'DISPLAY_EMAIL_SUMMARY_MODAL';
export const HIDE_EMAIL_SUMMARY_MODAL = 'HIDE_EMAIL_SUMMARY_MODAL';

// Email Summary Modal
export const DISPLAY_ALERT_MODAL = 'DISPLAY_ALER_MODAL';
export const HIDE_ALERT_MODAL = 'HIDE_ALERT_MODAL';

// Make content transparent while product options dropdown is open
export const DISPLAY_ONLY_DROPDOWN = 'DISPLAY_ONLY_DROPDOWN';
export const DISPLAY_ALL_CONTENT = 'DISPLAY_ALL_CONTENT';

// Options Menu
export const DISPLAY_OPTIONS_MENU = 'DISPLAY_OPTIONS_MENU';
export const HIDE_OPTIONS_MENU = 'HIDE_OPTIONS_MENU';

// Preview (graphics layers)
export const DISPLAY_PREVIEW = 'DISPLAY_PREVIEW';
export const HIDE_PREVIEW = 'HIDE_PREVIEW';


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/state/app-actions.ts